import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const BrandContext = createContext({ settings: null });

const DEFAULTS = {
  business_name: "Trisha Wealth",
  product_name: "Financial Health Check-Up",
  advisor_name: "Trisha Wealth Advisory",
  tagline: "Know Your Financial Health. Plan Your Future.",
  secondary_tagline:
    "Discover your financial strengths, identify important gaps and take the next step toward a more secure financial future.",
  email: "",
  mobile: "",
  whatsapp_number: "",
  website: "",
  logo_url: "",
  disclaimer: "",
  privacy_policy: "",
  social_links: {},
};

export function BrandProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    api
      .get("/settings")
      .then((res) => setSettings({ ...DEFAULTS, ...res.data }))
      .catch(() => setSettings(DEFAULTS));
  }, []);

  return <BrandContext.Provider value={{ settings, setSettings }}>{children}</BrandContext.Provider>;
}

export const useBrand = () => useContext(BrandContext).settings;
export const useBrandCtx = () => useContext(BrandContext);
